import {
  TApplicationContext,
  TInitConfigs,
  TProductContext,
} from 'global-mfe/types/builtInSupport'
import { isDevEnvironment, isStaging } from '../../utils/globalHeaderUtils'
import { publish } from '@signavio/dom-event-bus'
import { isAnalyticsPage, isProcessEditorPage } from './utils'

export const PPMSIDS = {
  PRODUCT_LINE: '73554900100700002981',
  PRODUCT: '73554900100800003813',
  PRODUCT_VERSION: '73554900100900006443',
  SOFTWARE_COMPONENT_VERSION: '73554900100200017823',
}

export const APPLICATION_ID = 'process-governance'

export const ACH_COMPONENTS = {
  PROCESS_GOVERNANCE: 'BPI-SIG-PG',
  ACCESS_MANAGEMENT: 'BPI-SIG-PG-AM',
  ANALYTICS_REPORT: 'BPI-SIG-PG-AR',
  EDITOR: 'BPI-SIG-PG-EDT',
  JAVASCRIPT_TASK: 'BPI-SIG-PG-JS',
  ONPREMISE: 'BPI-SIG-PG-ONP',
  MAIL_RELAY: 'BPI-SIG-PG-ONP-MR',
  SCRIPT_ENGINE: 'BPI-SIG-PG-ONP-SE',
}

export const PRODUCT_VERSION = '3.0'
export const PRODUCT_NAME = 'SAP Signavio Process Governance'

export const BUILT_IN_SUPPORT_CONTEXT_REFRESH =
  'built-in-support-context-refresh'

export const getACHComponent = (pathname: string) => {
  if (isProcessEditorPage(pathname)) {
    return ACH_COMPONENTS.EDITOR
  }

  if (isAnalyticsPage(pathname)) {
    return ACH_COMPONENTS.ANALYTICS_REPORT
  }

  return ACH_COMPONENTS.PROCESS_GOVERNANCE
}

export const getBuiltInSupportConfig = ({
  topOffset = '0px',
}): TInitConfigs => {
  const { hostname, pathname } = window.location
  const isTestEnv = isStaging(hostname) || isDevEnvironment(hostname)
  return {
    version: 'V1',
    animationMode: 'fly',
    resizable: true,
    useIcon: false,
    topOffset,
    targetEnvironment: isTestEnv ? 'test' : 'live',
    getProductContext: () => {
      return {
        productName: PRODUCT_NAME,
        productVersion: `${PRODUCT_NAME} ${PRODUCT_VERSION}`,
        PPMSIDs: [PPMSIDS.PRODUCT, PPMSIDS.PRODUCT_VERSION],
        productSupportACH: ACH_COMPONENTS.PROCESS_GOVERNANCE,
        productFallbackACH: ACH_COMPONENTS.PROCESS_GOVERNANCE,
      }
    },
    getApplicationContext: () => ({
      applicationName: PRODUCT_NAME,
      appId: APPLICATION_ID,
      achComponent: getACHComponent(pathname),
    }),
  }
}

export const updateBuiltInSupportContext = (
  context: TProductContext & TApplicationContext = {}
) => {
  publish(BUILT_IN_SUPPORT_CONTEXT_REFRESH, {
    getOverrideContext: () => {
      return Promise.resolve(context)
    },
  })
}
